import { faBookOpen, faBoxArchive, faCameraRetro, faCoins, faCubes, faDisplay, faDragon, faEarthAmerica, faHourglass, faMartiniGlass, faObjectGroup, faPaintBrush, faPencil, faT, faTrafficLight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { imageStyleListProps, styleImageGeneration } from "../types/imageStudio/images";
import { faMoon, faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoPopoverButton } from "../components/app/ImageStudio/InfoButton";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
//images
import flower3D from '..//assets/stylesExamples/purpleFlowers3D.png';
import flowerAnime from '../assets/stylesExamples/purpleFlowersAnime.png';
import flowerArtistic from '../assets/stylesExamples/purpleFlowersArtistic.png';
import flowerBrickToy from '../assets/stylesExamples/purpleFlowersBrickToy.png';
import flowerCharocal from '../assets/stylesExamples/purpleFlowersCharocal.png';
import flowerCinematic from '../assets/stylesExamples/purpleFlowersCinematic.png';
import flowerComic from '../assets/stylesExamples/purpleFlowersComic.png';
import flowerCyberpunk from '../assets/stylesExamples/purpleFlowersCyberpunk.png';
import flowerDigitalArt from '../assets/stylesExamples/purpleFlowersDigitalArt.png';
import flowerFantasy from '../assets/stylesExamples/purpleFlowersFantasy.png';
import flowerGlassArt from '../assets/stylesExamples/purpleFlowersGlassArt.png'
import flowerGolden from '../assets/stylesExamples/purpleFlowersGoldenArt.png'
import flowerGothic from '../assets/stylesExamples/purpleFlowersGothic.png';
import flowerLineArt from '../assets/stylesExamples/purpleFlowersLineArt.png';
import flowerMinimalistic from '../assets/stylesExamples/purpleFlowersMinimalistic.png';
import flowerOilPaint from '../assets/stylesExamples/purpleFlowersOilPainting.png';
import flowerPapercraft from '../assets/stylesExamples/purpleFlowersPapercraft.png';
import flowerPhotographic from '../assets/stylesExamples/purpleFlowersPhotographic.png';
import flowerRealistic from '../assets/stylesExamples/purpleFlowersRealistic.png';
import flowerStorybook from '../assets/stylesExamples/purpleFlowersStorybook.png';
import flowerSurreal from '../assets/stylesExamples/purpleFlowersSurreal.png';
import flowerVintage from '../assets/stylesExamples/purpleFlowersVintage.png';
import flowerWatercolor from '../assets/stylesExamples/purpleFlowersWaterColor.png';
import flowerNoir from '../assets/stylesExamples/purpleFlowersNoir.png';
import flowerNone from '../assets/stylesExamples/purpleFlowersNone.png';
import flowerWoodenBlocks from '../assets/stylesExamples/purpleFlowersWoodenBlocks.png';
import flowerBlockWorld from '../assets/stylesExamples/purpleFlowersBlockWorld.png';
//text styles
import flowerTextGolden from '../assets/stylesExamples/purpleFlowersGolden-text.png';
import flowerTextCandy from '../assets/stylesExamples/purpleFlowersCandy.png';
import flowerTextCrystal from '../assets/stylesExamples/purpleFlowersCrystal.png';
import flowerTextDark from '../assets/stylesExamples/purpleFlowersDark.png';
import flowerTextFire from '../assets/stylesExamples/purpleFlowersFire.png';
import flowerTextIce from '../assets/stylesExamples/purpleFlowersIce.png';
import flowerTextFlower from '../assets/stylesExamples/purpleFlowersFlowerPower.png';
import flowerTextGalaxy from '../assets/stylesExamples/purpleFlowersGalaxy.png';
import flowerTextNature from '../assets/stylesExamples/prupleFlowersNature.png';
import flowerTextSmoke from '../assets/stylesExamples/purpleFlowersSmoke.png';
import flowerTextMetallic from '../assets/stylesExamples/purpleFlowersMetallic.png';
import flowerTextTransition from '../assets/stylesExamples/purpleFlowersTransition.png';
import flowerTextLiquid from '../assets/stylesExamples/purpleFlowersLiquid.png';
import flowerTextNeon from '../assets/stylesExamples/purpleFlowersNeon.png';
import flowerTextMushroom from '../assets/stylesExamples/purpleFlowerMushrooms.png';

import sengiTextGolden from '../assets/stylesExamples/sengiTextGolden2.png';
import sengiTextCandy from '../assets/stylesExamples/sengiTextCandy2.png';
import sengiTextCrystal from '../assets/stylesExamples/sengiTextCrystal2.png';
import sengiTextDark from '../assets/stylesExamples/sengiTextDark1.png';
import sengiTextFire from '../assets/stylesExamples/sengiTextFire2.png';
import sengiTextIce from '../assets/stylesExamples/sengiTextIce2.png';
import sengiTextFlower from '../assets/stylesExamples/sengiTextFlower1.png';
import sengiTextGalaxy from '../assets/stylesExamples/sengiTextGalaxy2.png';
import sengiTextNature from '../assets/stylesExamples/sengiTextNature2.png';
import sengiTextSmoke from '../assets/stylesExamples/sengiTextSmoke2.png';
import sengiTextMetallic from '../assets/stylesExamples/sengiTextMetallic2.png';
import sengiTextTransition from '../assets/stylesExamples/sengiTextTransition1.png';
import sengiTextLiquid from '../assets/stylesExamples/sengiTextLiquid1.png';
import sengiTextNeon from '../assets/stylesExamples/sengiTextNeon2.png';
import sengiTextMushroom from '../assets/stylesExamples/sengiTextMushrooms6.png';

export const useImageStyles = () => {
    const { t } = useTranslation("imageStudioSettings");

    const stylesList = useMemo<imageStyleListProps[]>(() => ([
    {
        item: 'none',
        name: t("styles.names.none"),
        category: [t("styles.categories.none")],
        icon: faXmark,
        description: (
            <div>
                <p>{t("styles.descriptions.none")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerNone} width='200px' alt="purple flowers example" />
            </div>
        )
    },
    {
        item: '3d render',
        name: t("styles.names.render3d"),
        icon: faCubes,
        category: [t("styles.categories.craftMaterial")],
        description: (
            <div>
                <p>{t("styles.descriptions.render3d")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flower3D} width='200px' alt="purple flowers 3d render example" />
            </div>
        )
    },
    {
        item: 'anime',
        name: t("styles.names.anime"),
        icon: faDragon,
        category: [t("styles.categories.illustration")],
        description: (
            <div>
                <p>{t("styles.descriptions.anime")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerAnime} width='200px' alt="purple flowers anime example" />
            </div>
        )
    },
    {
        item: 'artistic',
        name: t("styles.names.artistic"),
        icon: faPaintBrush,
        category: [t("styles.categories.illustration")],
        description: (
            <div>
                <p>{t("styles.descriptions.artistic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerArtistic} width='200px' alt="purple flowers artistic example" />
            </div>
        )
    },
    {
        item: 'block-world',
        name: t("styles.names.blockWorld"),
        icon: faCubes,
        category: [t("styles.categories.toyBlock"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.blockWorld")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerBlockWorld} width='200px' alt="purple flowers block world example" />
            </div>
        )
    },
    {
        item: 'brick-toy',
        name: t("styles.names.brickToy"),
        icon: faCubes,
        category: [t("styles.categories.toyBlock"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.brickToy")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerBrickToy} width='200px' alt="purple flowers brick toy example" />
            </div>
        )
    },
    {
        item: 'charcoal',
        name: t("styles.names.charcoal"),
        icon: faPencil,
        category: [t("styles.categories.painting"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.charcoal")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerCharocal} width='200px' alt="purple flowers charcoal example" />
            </div>
        )
    },
    {
        item: 'cinematic',
        name: t("styles.names.cinematic"),
        icon: faCameraRetro,
        category: [t("styles.categories.cinemaMood")],
        description: (
            <div>
                <p>{t("styles.descriptions.cinematic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerCinematic} width='200px' alt="purple flowers cinematic example" />
            </div>
        )
    },
    {
        item: 'comic',
        name: t("styles.names.comic"),
        icon: faBookOpen,
        category: [t("styles.categories.illustration")],
        description: (
            <div>
                <p>{t("styles.descriptions.comic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerComic} width='200px' alt="purple flowers comic example" />
            </div>
        )
    },
    {
        item: 'cyberpunkt',
        name: t("styles.names.cyberpunk"),
        icon: faTrafficLight,
        category: [t("styles.categories.lights"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.cyberpunk")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerCyberpunk} width='200px' alt="purple flowers cyberpunk example" />
            </div>
        )
    },
    {
        item: 'digital art',
        name: t("styles.names.digitalArt"),
        icon: faDisplay,
        category: [t("styles.categories.illustration")],
        description: (
            <div>
                <p>{t("styles.descriptions.digitalArt")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerDigitalArt} width='200px' alt="purple flowers digital art example" />
            </div>
        )
    },
    {
        item: 'fantasy',
        name: t("styles.names.fantasy"),
        icon: faDragon,
        category: [t("styles.categories.fantasyDark"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.fantasy")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerFantasy} width='200px' alt="purple flowers fantasy example" />
            </div>
        )
    },
    {
        item: 'glass-art',
        name: t("styles.names.glassArt"),
        icon: faMartiniGlass,
        category: [t("styles.categories.craftMaterial"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.glassArt")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerGlassArt} width='200px' alt="purple flowers glass art example" />
            </div>
        )
    },
    {
        item: 'golden-art',
        name: t("styles.names.goldenArt"),
        category: [t("styles.categories.craftMaterial"), t("styles.categories.experimental")],
        icon: faCoins,
        description: (
            <div>
                <p>{t("styles.descriptions.goldenArt")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerGolden} width='200px' alt="purple flowers golden art example" />
            </div>
        )
    },
    {
        item: 'gothic',
        name: t("styles.names.gothic"),
        icon: faMoon,
        category: [t("styles.categories.fantasyDark"), t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.gothic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerGothic} width='200px' alt="purple flowers gothic example" />
            </div>
        )
    },
    {
        item: 'line-art',
        name: t("styles.names.lineArt"),
        category: [t("styles.categories.illustration")],
        icon: faPencil,
        description: (
            <div>
                <p>{t("styles.descriptions.lineArt")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerLineArt} width='200px' alt="purple flowers line art example" />
            </div>
        )
    },
    {
        item: 'minimalistic',
        name: t("styles.names.minimalistic"),
        category: [t("styles.categories.cinemaMood"), t("styles.categories.experimental")],
        icon: faBoxArchive,
        description: (
            <div>
                <p>{t("styles.descriptions.minimalistic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerMinimalistic} width='200px' alt="purple flowers minimalistic example" />
            </div>
        )
    },
    {
        item: 'noir',
        name: t("styles.names.noir"),
        category: [t("styles.categories.cinemaMood")],
        icon: faMoon,
        description: (
            <div>
                <p>{t("styles.descriptions.noir")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerNoir} width='200px' alt="purple flowers noir example" />
            </div>
        )
    },
    {
        item: 'oil-painting',
        name: t("styles.names.oilPainting"),
        category: [t("styles.categories.painting")],
        icon: faPaintBrush,
        description: (
            <div>
                <p>{t("styles.descriptions.oilPainting")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerOilPaint} width='200px' alt="purple flowers oil painting example" />
            </div>
        )
    },
    {
        item: 'papercraft',
        name: t("styles.names.papercraft"),
        category: [t("styles.categories.craftMaterial")],
        icon: faPaperPlane,
        description: (
            <div>
                <p>{t("styles.descriptions.papercraft")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerPapercraft} width='200px' alt="purple flowers papercraft example" />
            </div>
        )
    },
    {
        item: 'photographic',
        name: t("styles.names.photographic"),
        category: [t("styles.categories.realism")],
        icon: faCameraRetro,
        description: (
            <div>
                <p>{t("styles.descriptions.photographic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerPhotographic} width='200px' alt="purple flowers photographic example" />
            </div>
        )
    },
    {
        item: 'realistic',
        name: t("styles.names.realistic"),
        category: [t("styles.categories.realism")],
        icon: faEarthAmerica,
        description: (
            <div>
                <p>{t("styles.descriptions.realistic")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerRealistic} width='200px' alt="purple flowers realistic example" />
            </div>
        )
    },
    {
        item: 'storybook',
        name: t("styles.names.storybook"),
        category: [t("styles.categories.illustration")],
        icon: faBookOpen,
        description: (
            <div>
                <p>{t("styles.descriptions.storybook")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerStorybook} width='200px' alt="purple flowers storybook example" />
            </div>
        )
    },
    {
        item: 'surreal',
        name: t("styles.names.surreal"),
        icon: faHourglass,
        category: [t("styles.categories.experimental")],
        description: (
            <div>
                <p>{t("styles.descriptions.surreal")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerSurreal} width='200px' alt="purple flowers surreal example" />
            </div>
        )
    },
    {
        item: 'vintage',
        name: t("styles.names.vintage"),
        category: [t("styles.categories.cinemaMood")],
        icon: faCameraRetro,
        description: (
            <div>
                <p>{t("styles.descriptions.vintage")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerVintage} width='200px' alt="purple flowers vintage example" />
            </div>
        )
    },
    {
        item: 'water-color',
        name: t("styles.names.waterColor"),
        category: [t("styles.categories.painting")],
        icon: faPaintBrush,
        description: (
            <div>
                <p>{t("styles.descriptions.waterColor")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerWatercolor} width='200px' alt="purple flowers watercolor example" />
            </div>
        )
    },
    {
        item: 'wooden-blocks',
        name: t("styles.names.woodenBlocks"),
        category: [t("styles.categories.toyBlock"), t("styles.categories.experimental")],
        icon: faCubes,
        description: (
            <div>
                <p>{t("styles.descriptions.woodenBlocks")}</p>

                <p>
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerWoodenBlocks} width='200px' alt="purple flowers wooden blocks example" />
            </div>
        )
    },
    {
        item: 'textCandy',
        name: t("styles.names.textCandy"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textCandy")}</p>

                <p>
                    <i>{t("styles.exampleText", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextCandy} width="200px" alt="text candy style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextCandy} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textCrystal',
        name: t("styles.names.textCrystal"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textCrystal")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextCrystal} width="200px" alt="text crystal style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextCrystal} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textDark',
        name: t("styles.names.textDark"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textDark")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextDark} width="200px" alt="text dark style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextDark} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textFire',
        name: t("styles.names.textFire"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textFire")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextFire} width="200px" alt="text fire style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextFire} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textFlower',
        name: t("styles.names.textFlower"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textFlower")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextFlower} width="200px" alt="text flower style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextFlower} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textGalaxy',
        name: t("styles.names.textGalaxy"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textGalaxy")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextGalaxy} width="200px" alt="text galaxy style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextGalaxy} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textGolden',
        name: t("styles.names.textGolden"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textGolden")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextGolden} width="200px" alt="text golden style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextGolden} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textIce',
        name: t("styles.names.textIce"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textIce")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextIce} width="200px" alt="text ice style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextIce} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textLiquid',
        name: t("styles.names.textLiquid"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textLiquid")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextLiquid} width="200px" alt="text liquid style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextLiquid} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textMetallic',
        name: t("styles.names.textMetallic"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textMetallic")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextMetallic} width="200px" alt="text metallic style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextMetallic} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textMushroom',
        name: t("styles.names.textMushroom"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textMushroom")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextMushroom} width="200px" alt="text mushroom style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextMushroom} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textNature',
        name: t("styles.names.textNature"),
        category: [t("styles.categories.textStyles"), t("styles.categories.experimental")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textNature")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextNature} width="200px" alt="text nature style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextNature} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textNeon',
        name: t("styles.names.textNeon"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textNeon")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextNeon} width="200px" alt="text neon style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextNeon} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textSmoke',
        name: t("styles.names.textSmoke"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textSmoke")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextSmoke} width="200px" alt="text smoke style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextSmoke} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textTransition',
        name: t("styles.names.textTransition"),
        category: [t("styles.categories.textStyles")],
        icon: faT,
        description: (
            <div>
                <p>{t("styles.descriptions.textTransition")}</p>

                <p>
                    <i>{t("styles.example", { value: "SENGI" })}</i>
                </p>

                <img src={sengiTextTransition} width="200px" alt="text transition style example" />

                <p className="mt-1">
                    <i>{t("styles.example", { value: t("styles.purpleFlowers") })}</i>
                </p>

                <img src={flowerTextTransition} width="200px" alt="text candy style example" />
            </div>
        )
    }
]), [t]);

    const styleCategoryTags = Array.from(
    new Set(stylesList.flatMap(style => style.category ?? []))
).sort();

    const styleFilterGroups = [
    {
        name: t("styles.filterCategory"),
        tags: styleCategoryTags,
        getItemTags: (style: imageStyleListProps) => style.category ?? []
    }
];

    const renderStyleDropdownItem = (x: imageStyleListProps) => (
    <div className="row p-0 m-0 align-items-center">
        {x.icon && (
            <div className="col-auto p-0 m-0 me-2">
                <FontAwesomeIcon icon={x.icon} />
            </div>
        )}

        <div className="col p-0 m-0">
            <div>{x.name}</div>
            <div className="small opacity-75">{(x.category ?? []).join(", ")}</div>
        </div>

        {x.description && (
            <div className="col-auto mb-1 p-0">
                <InfoPopoverButton width={320} placement="right">
                    <div>{x.description}</div>
                </InfoPopoverButton>
            </div>
        )}
    </div>
);

    return { stylesList, styleCategoryTags, styleFilterGroups, renderStyleDropdownItem };
};